// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCheckMark_root__1s_8_"};